import { render, staticRenderFns } from "./InformationDetail.vue?vue&type=template&id=87ba28b4"
import script from "./InformationDetail.vue?vue&type=script&lang=js"
export * from "./InformationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87ba28b4')) {
      api.createRecord('87ba28b4', component.options)
    } else {
      api.reload('87ba28b4', component.options)
    }
    module.hot.accept("./InformationDetail.vue?vue&type=template&id=87ba28b4", function () {
      api.rerender('87ba28b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/referral-management/search/InformationDetail.vue"
export default component.exports